import api from "./api/api";

const DEFAULT_ALERT_FACILITY_TOGGLE_API = '/api/default-alert-facility-toggle';

// Toggle facility for default alert
export const toggleDefaultAlertFacility = async (alertReportId, alertKey, facilityId, enabled, customAlertSlug) => {
    try {
        const response = await api.post(`${DEFAULT_ALERT_FACILITY_TOGGLE_API}/toggle`, {
            alertReportId,
            alertKey,
            facilityId,
            enabled,
            customAlertSlug // Pass this to backend
        });
        return response;
    } catch (error) {
        console.error('Error toggling default alert facility:', error);
        throw error;
    }
};

// Get default alert facility toggles
export const getDefaultAlertFacilityToggles = async (params = {}) => {
    try {
        const response = await api.get(`${DEFAULT_ALERT_FACILITY_TOGGLE_API}`, { params });
        return response;
    } catch (error) {
        console.error('Error getting default alert facility toggles:', error);
        throw error;
    }
};

// Bulk toggle facilities for default alerts
// export const bulkToggleDefaultAlertFacilities = async (alertReportId, toggles) => {
//     try {
//         const response = await api.post(`${DEFAULT_ALERT_FACILITY_TOGGLE_API}/bulk-toggle`, {
//             alertReportId,
//             toggles
//         });
//         return response;
//     } catch (error) {
//         console.error('Error bulk toggling default alert facilities:', error);
//         throw error;
//     }
// }; 